import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import log from '../Loging/Lisc.png';
import styles from '../Loging/Login.module.css'; // Importar el módulo CSS
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { getUsuarios, validateToken } from '../../redux/actions';
import { useNavigate } from 'react-router-dom';
import SnowEffect from "./SnowEffect";


export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [cedula, setCedula] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();
  const usuario = useSelector((state) => state.usuario);
  const usuarioError = useSelector((state) => state.usuarioError); // Seleccionar el error de usuario
  const token = useSelector((state) => state.token);

  useEffect(() => {
    if (token.message === 'Token válido') {
      navigate('/home');
    } else if (token.message === 'Token inválido') {
      setError('El token es inválido, por favor verifíquelo.');
    } else if (token.message === 'Token expirado') {
      setError('El token ha expirado, por favor genere otro.');
    }
  }, [token, navigate]);

  const onSubmitCedula = async (data) => {
    setLoading(true); // 👈 Bloquea el botón
    setCedula(data.cedula);
    await dispatch(getUsuarios(data.cedula));
    if (usuarioError === 'Documento no existe o esta deshabilitado, Comuniquese con el área TI') {
      setError(usuarioError);
    } else {
      setError('');
      setStep(2);
    }
    setLoading(false); // 👈 Vuelve a habilitar el botón
  };

  const onSubmitToken = (data) => {
    setError('');
    dispatch(validateToken(data.token));
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.glassBox}>
        <div className={styles.loginHeader}>
          <img src={log} alt="Incolab Logo" className={styles.logo} />
          <h1>SIGESTIC</h1>
          <p>Sistema de Gestión de Tickets</p>
        </div>

        <div className={styles.loginBody}>
          {step === 1 && (
            <form onSubmit={handleSubmit(onSubmitCedula)} className={styles.form}>
              <div className={styles.inputGroup}>
                <label htmlFor="cedula">Documento de Identidad</label>
                <input
                  type="text"
                  id="cedula"
                  placeholder="Ingrese su documento"
                  {...register('cedula', { required: true, minLength: 4, maxLength: 12 })}
                  className={styles.input}
                />
                {errors.cedula && <span className={styles.errorText}>Documento inválido (4-12 caracteres)</span>}
                {usuarioError === 'Documento no existe o esta deshabilitado, Comuniquese con el área TI' &&
                  <span className={styles.errorText}>{usuarioError}</span>}
              </div>
              <button
                type="submit"
                className={styles.submitButton}
                disabled={loading}
              >
                {loading ? 'Validando...' : 'Acceder'}
              </button>
            </form>
          )}

          {step === 2 && (
            <div className={styles.tokenSection}>
              <p className={styles.infoText}>
                Hemos enviado un token a su correo electrónico. Por favor ingréselo para continuar.
              </p>
              {error && <div className={styles.alertError}>{error}</div>}
              <form onSubmit={handleSubmit(onSubmitToken)} className={styles.form}>
                <div className={styles.inputGroup}>
                  <label htmlFor="token">Código Token</label>
                  <input
                    type="text"
                    id="token"
                    placeholder="Ingrese el código"
                    {...register('token', { required: true })}
                    className={styles.input}
                  />
                  {errors.token && <span className={styles.errorText}>El token es obligatorio</span>}
                </div>
                <button type="submit" className={styles.submitButton}>Verificar</button>
              </form>
            </div>
          )}
        </div>

        <div className={styles.loginFooter}>
          <span className={styles.versionBadge}>v 2.1.1</span>
          <p>Desarrollado por el equipo Gestión TI © Incolab Services Colombia 2026</p>
        </div>
      </div>
    </div>
  );
}
